// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"ac1e5c3bf7fdd66df597","655":"4c8df9455c9f8d5014b8"}[chunkId] + ".js";
};